module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_3016.21407705.png";